import React from 'react'

export default function Projects() {
  return (
    <section className="resume-section" id="projects">
      <div className="resume-section-content">
        <h2 className="mb-5">Projects</h2>
        <div className="d-flex flex-column flex-md-row justify-content-between mb-5">
          <div className="flex-grow-1">
            <h3 className="mb-0">BMW Finance</h3>
            <div className="subheading mb-3">Eviden (Atos-Syntel)</div>
            <p>Commercial Finance is a part of Financial Services for dealers to get loans for maintaining stock while Retail Finance provides loans to customers for financing or leasing vehicles. The customer's credit history is
              checked before loan approval and regular monthly payments are made during the loan tenure.
            </p> <p>
              <b>Technologies Used </b>
              ReactJS, Asp.Net Core MVC, Web API, C#, SQL Server,
              Octopus Deployment, GitHub, Azure DevOps, Agile,
              Jquery

            </p>
          </div>
          <div className="flex-shrink-0"><span className="text-primary">December 2022 - Present</span></div>
        </div>
        <div className="d-flex flex-column flex-md-row justify-content-between mb-5">
          <div className="flex-grow-1">
            <h3 className="mb-0">T-Mobile Portals development</h3>
            <div className="subheading mb-3">Eviden (Atos-Syntel)</div>
            <p>T-Mobile stands at the forefront of the telecommunication's industry. Through the development of cutting-edge internal tools and public portals, we efficiently manage diverse settings and public interactions with utmost precision.
            </p> <p>
              <b>Technologies Used </b>
              ReactJS, Asp.Net MVC, Web API, C#, SQL Server, Octopus Deployment, TFS, Agile, Jquery, Unit Testing
            </p>
          </div>
          <div className="flex-shrink-0"><span className="text-primary">June 2021 - December 2022</span></div>
        </div>

        <div className="d-flex flex-column flex-md-row justify-content-between mb-5">
          <div className="flex-grow-1">
            <h3 className="mb-0">Defi LOS</h3>
            <div className="subheading mb-3">Fiserv </div>
            <p>As a member of the product development team, worked on a Loan Origination System in the banking domain. The system manages core business processes through data and workflow management, and pricingbilling modules.
            </p> <p>
              <b>Technologies Used </b>
              Asp.Net Core MVC, Web API, C#, SQL Server, Octopus Deployment, TFS, GitHub,  Agile, Jquery, Azure DevOps, NUnit 
            </p>
          </div>
          <div className="flex-shrink-0"><span className="text-primary">August 2019 - June 2021</span></div>
        </div>

        <div className="d-flex flex-column flex-md-row justify-content-between mb-5">
          <div className="flex-grow-1">
            <h3 className="mb-0">Dodge Data Analytics</h3>
            <div className="subheading mb-3">Harman Connected Services </div>
            <p>Dodge Data & Analytics is an online bidding platform for construction professionals. The platform provides a vast and accurate database of construction projects. The DDA Dodge Global Network integrates all of DDA Construction’s information sources. BidPro offers a specialized dashboard for contractors, while the Call Center is a Windows application that collects survey information. Sweets is a trusted source of building product information for A/E/C professionals. 
            </p> <p>
              <b>Technologies Used </b>
              Asp.Net MVC, Web API, C#, SQL Server, Oracle, IIS , GitHub, Agile, Jquery, Azure DevOps, NUnit, HTML, CSS
            </p>
          </div>
          <div className="flex-shrink-0"><span className="text-primary">February 2015 - August 2019</span></div>
        </div>

        <div className="d-flex flex-column flex-md-row justify-content-between mb-5">
          <div className="flex-grow-1">
            <h3 className="mb-0">TradeStation</h3>
            <div className="subheading mb-3">Elogmar Enterprises </div>
            <p>This is a web app for a US pharmaceutical company with three logins: Vendor, Sales, and Customer. Each login has different constraints, UI, and functionality. The app's goal is to provide all necessary features on a single screen, covering all the operational requirements of the client. 
            </p> 
          </div>
          <div className="flex-shrink-0"><span className="text-primary">December 2013 - February 2015</span></div>
        </div>

        <div className="d-flex flex-column flex-md-row justify-content-between mb-5">
          <div className="flex-grow-1">
            <h3 className="mb-0">Complete College Automation</h3>
            <div className="subheading mb-3">Infosoft Global tech</div>
            <p>CCA is a web app designed for colleges. It simplifies college management by providing an attractive and secure environment to manage student and staff data. Its core objective is to reduce the time spent searching for appropriate candidates. 
            </p> 
          </div>
          <div className="flex-shrink-0"><span className="text-primary">January 2012 - December 2013</span></div>
        </div>

        <div className="d-flex flex-column flex-md-row justify-content-between mb-5">
          <div className="flex-grow-1">
            <h3 className="mb-0">ELINT Power</h3>
            <div className="subheading mb-3">Elink Software Technologies Pvt Ltd.</div>
            <p>ELint Power® is a web-based tool developed by domain experts to help electrical distribution companies improve their operations. It has four service verticals, each with integrated modules, and is certified by professional software testing organizations and the Indian Association of Energy Management Professionals (IAEMP). 
            </p> 
          </div>
          <div className="flex-shrink-0"><span className="text-primary">June 2011 - January 2012</span></div>
        </div>
      </div>
    </section>
  )
}
